// Parse "5m", "90s", "1h 30m", "2 min", "45 sec" into seconds; returns null on failure.
export function parseDuration(str) {
  if (!str) return null;
  const s = String(str).trim().toLowerCase();
  if (!s) return null;
  // Bare number → minutes (friendly default)
  if (/^\d+(\.\d+)?$/.test(s)) return Math.round(parseFloat(s) * 60);
  const parts = [...s.matchAll(/(\d+(?:\.\d+)?)\s*(hours?|hrs?|h|minutes?|mins?|m|seconds?|secs?|s)/gi)];
  if (parts.length === 0) return null;
  let total = 0;
  for (const p of parts) {
    const n = parseFloat(p[1]);
    const unit = p[2].toLowerCase();
    if (unit.startsWith("h")) total += n * 3600;
    else if (unit.startsWith("m")) total += n * 60;
    else total += n;
  }
  return Math.round(total);
}

export function formatDuration(seconds) {
  const s = Math.max(0, Math.floor(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
  return `${m}:${String(sec).padStart(2, "0")}`;
}

// Given a step line like "Whisk for 3 minutes. [timer: 3m]", return
// { text: "Whisk for 3 minutes.", seconds: 180 } — text has the tag stripped.
export function extractTimer(rawStep) {
  if (!rawStep) return { text: "", seconds: null };
  const m = /\[\s*timer\s*:\s*([^\]]+?)\s*\]/i.exec(rawStep);
  if (!m) return { text: rawStep.trim(), seconds: null };
  const seconds = parseDuration(m[1]);
  const text = (rawStep.slice(0, m.index) + rawStep.slice(m.index + m[0].length)).trim();
  return { text, seconds };
}
